import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ProductHeroNew } from "@/components/products/ProductHeroNew";
import { SaaSPlatformNew } from "@/components/products/SaaSPlatformNew";
import { WebPortalNew } from "@/components/products/WebPortalNew";
import { MobileAppsNew } from "@/components/products/MobileAppsNew";
import { FeatureComparisonNew } from "@/components/products/FeatureComparisonNew";
import { ProductCTANew } from "@/components/products/ProductCTANew";
import { SEO, productsPageSchema } from "@/components/SEO";

const Products = () => {
  return (
    <main className="min-h-screen bg-background">
      <SEO 
        title="EV Charging Software - SaaS Platform & Mobile Apps"
        description="Enterprise EV charging software with cloud SaaS platform, mobile apps for drivers, and web portal for operators. OCPP 2.0.1 compliant."
        keywords="EV charging software, SaaS platform, mobile app, OCPP, fleet management"
        canonicalUrl="/products"
        structuredData={productsPageSchema}
      />
      <Navbar />
      <ProductHeroNew />
      <SaaSPlatformNew />
      <WebPortalNew />
      <MobileAppsNew />
      <FeatureComparisonNew />
      <ProductCTANew />
      <Footer />
    </main>
  );
};

export default Products;
